import styled from 'styled-components'

 const MainComponent = styled.div`
    max-width: 120rem;
    margin: auto;
    width: 92%;
`
export default MainComponent;